import { buildApiGatewayDomainForClient } from './buildApiGatewayDomainForClient'

export function buildApiGatewayDomain() {
  const { hostname } = window.location
  return buildApiGatewayDomainForClient(hostname)
}
